module.exports = __webpack_public_path__ + "static/img/qrcode.3f09820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/qrcode.png
// module id = g2e1
// module chunks = 1